import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { TdspBaseEntityService } from "../rest-common.service";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class TdspCreativeService extends TdspBaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  get resource_url(): string {
    return `${this.activeBaseUrl}/creative/`;
  }

  getCreativeSizes(params = {}) {
    let url = this.buildUrl(`${this.resource_url}sizes`, "", params);
    return this.get(url);
  }

  getCreativeLimitDetails(params = {}) {
    let url = this.buildUrl(`${this.resource_url}asset-limits`, "", params);
    return this.get(url);
  }

  getDOOHInventory(params = {}) {
    let url = this.buildUrl(`${this.resource_url}viooh-publishers`, "", params);
    return this.get(url);
  }

  activateDeactivateCreative(
    id,
    action: "activate" | "deactivate",
    params = {}
  ) {
    let url = this.buildUrl(
      `${this.resource_url}${id}/${action}/`,
      "",
      params
    );
    return this.put(url, {});
  }
}
